<template>
    <div class="miniprogram_selector">
        <div class="miniprogram_selector__content">
            <as-selector @change="onChangeType" :default="typeDefaultData" :options="typeSelects"></as-selector>
            <as-mallitem-advanced-selector v-if="typeData.value === 2" :placeholder="pageDefaultLabel" @change="onChangeMallItem" :load-data="loadMallItemData" :multiple="false"></as-mallitem-advanced-selector>
            <as-selector ref="activitySelector" @change="onChangeResearch" :show-empty-visible="true" :empty-text="worksEmptyText" :placeholder="pageDefaultLabel" :options="researchOptions" v-else-if="[69, 71].includes(typeData.value)"></as-selector>
            <as-work-advanced-selector v-else-if="typeData.value === 11" :placeholder="pageDefaultLabel" :value="pageDefault ? pageDefault.id : null" @change="onChangeWork" :load-data="loadWorkData"></as-work-advanced-selector>
        </div>
        <div class="miniprogram_selector__example">
            <p class="miniprogram_selector__tips">{{ typeData.tips }}</p>
            <img class="miniprogram_selector__image" :src="typeData.imageUrl" alt="">
        </div>
    </div>
</template>
<script>
import AsSelector from '@/components/selector';
import AsMallitemAdvancedSelector from '@/components/mallitem-advanced-selector';
import AsWorkAdvancedSelector from '@/components/work-advanced-selector'
const TypeConfig = {
    'mall': {
        label: '商城首页',
        getPage(data, type) {
            return type === 1? `&view=3` : `pages/mall/index.html`;
        }
    },
    2: {
        label: '商品',
        getPage(data, type) {
            return type === 1 ? `&view=4&modelId=${data.id}` : `pages/mall/index.html?scene=2@${data.id}`;
        }
    },
    11: {
        label: '作品',
        getPage(data, type) {
            return  type === 1 ? `&view=8&modelId=${data.id}` : `pages/works/index.html?scene=11@${data.id}`;
        }
    },
    69: {
        label: '活动',
        sync: true,
        loadDataCallback(data) {
            this.researchOptions = data;
            if (this.defaultActivitySelect && data && data.length === 1) {
                this.$nextTick(() => {
                    this.$refs.activitySelector && this.$refs.activitySelector.onItemClicked(0);
                })
            }
        },
        getPage(data, type) {
            return `pages/mine/index.html?scene=69@${data.id}`;
        }
    },
    70: {
        label: '预约首页',
        getPage(data, type) {
            return  type === 1 ? `&view=5` : `pages/home/index.html`;
        }
    },
    71: {
        label: '抽奖活动',
        sync: true,
        loadDataCallback(data) {
            this.researchOptions = data;
            if (this.defaultActivitySelect && data && data.length === 1) {
                this.$nextTick(() => {
                    this.$refs.activitySelector && this.$refs.activitySelector.onItemClicked(0);
                })
            }
        },
        getPage(data, type) {
            return  `pages/mine/index.html?scene=lottery${data.type}`;
        }
    },
    "mine": {
        label: '我的页面',
        getPage(data, type) {
            return type === 1 ? `&view=2` : `pages/mine/index.html`
        }
    }
}
export default {
    name: 'AsMiniprogramSelector',
    components: {
        AsSelector,
        AsMallitemAdvancedSelector,
        AsWorkAdvancedSelector,
    },
    props: {
        typeDefault: Object,
        loadData: Function,
        pageDefault: Object,
        defaultActivitySelect: {
            type: Boolean,
            default: true
        },
        // 小程序类型 0/微信小程序 1/美一客web小程序
        appletType: {
            type: Number,
            default: 0
        },
        worksEmptyText: {
            type: String,
            default: '暂无数据'
        },
        isGreeting: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        typeSelects() {
            let list = this.typeList.filter((item) => item.appletTypes.includes(this.appletType))
            if(!this.isGreeting) {
                list = list.filter(item => !['mall', 'mine'].includes(item.value))
            }
            return list
        },
        typeDefaultData() {
            return this.typeData || this.typeDefault;
        },
        pageDefaultLabel() {
            if (this.pageDefault) return this.pageDefault.name;
            return `请选择${this.typeConfig.label}`;
        },
    },
    data() {
        return {
            typeList: [
                { name: '我的页面', value: 'mine', appletTypes: [0, 1], imageUrl: 'https://img.meiguanjia.net/shair-ui/miniprogram-selector/minepage.png', tips: '示意图'},
                { name: '商城首页', value: 'mall', appletTypes: [0, 1], imageUrl: 'https://img.meiguanjia.net/shair-ui/miniprogram-selector/mallindex.png', tips: '示意图'},
                { name: '商城商品', value: 2, appletTypes: [0, 1], imageUrl: 'https://img.meiguanjia.net/shair-ui/miniprogram-selector/mallitem.png', tips: '示意图' },
                { name: '手艺人作品', value: 11, appletTypes: [0, 1], imageUrl: 'https://img.meiguanjia.net/shair-ui/miniprogram-selector/work.png', tips: '示意图' },
                { name: '调研活动', value: 69, appletTypes: [0], imageUrl: 'https://img.meiguanjia.net/shair-ui/miniprogram-selector/research.png', tips: '示意图' },
                { name: '预约首页', value: 70, appletTypes: [0, 1], imageUrl: 'https://img.meiguanjia.net/shair-ui/miniprogram-selector/reservation.png', tips: '示意图' },
                { name: '抽奖活动', value: 71, appletTypes: [0], imageUrl: 'https://img.meiguanjia.net/shair-ui/miniprogram-selector/lottery.png', tips: '示意图' },
            ],
            typeConfig: {},
            typeData: {},
            researchOptions: [],
        }
    },
    methods: {
        loadWorkData(data, done) {
            this.loadData({
                ...data,
                ...this.typeData
            }, done);
        },
        loadMallItemData(done) {
            this.loadData(this.typeData, done);
        },
        onChangeType(data) {
            if (data.value === this.typeData.value) return;
            this.typeConfig = TypeConfig[data.value];
            this.typeData = data;
            this.triggerEvent({});
            const { sync, loadDataCallback } = this.typeConfig;
            if (sync) {
                this.loadData && this.loadData(data, loadDataCallback.bind(this));
            }
            if (data.value === 70) {
                const page = this.typeConfig.getPage('', this.appletType);
                this.triggerEvent({ page, imageUrl: 'https://img.meiguanjia.net/mgj-crm/share/service.png', });
            } else if(['mine', 'mall'].includes(data.value)) {
                const page = this.typeConfig.getPage('', this.appletType);
                this.triggerEvent({page, imageUrl: ''});
            }
        },
        onChangeResearch(data) {
            const page = this.typeConfig.getPage(data, this.appletType);
            this.triggerEvent({
                page,
                data,
                imageUrl: 'https://img.meiguanjia.net/mgj-crm/share/survey.png',
            });
        },
        onChangeMallItem(nodeList) {
            const data = nodeList[0];
            const page = this.typeConfig.getPage(data, this.appletType);
            this.triggerEvent({
                page,
                data,
            })
        },
        onChangeWork(data) {
            const page = this.typeConfig.getPage(data, this.appletType);
            this.triggerEvent({
                page,
                data,
            })
        },
        triggerEvent(data) {
            data.type = this.typeData.value;
            this.$emit('change', data);
        }
    },
    mounted() {
        let typeData;
        let typeList = this.typeSelects;
        if (this.typeDefault && this.typeDefault.value) {
            typeData = typeList.find((item) => item.value === this.typeDefault.value)
        }
        if (typeData) {
            this.onChangeType(typeData);
        } else {
            this.typeData = typeList[0];
            this.typeConfig = TypeConfig[this.typeData.value];
        }
    }
}
</script>
<style lang="scss">
.miniprogram_selector {
    display: inline-flex;
    flex-direction: column;
    .miniprogram_selector__content {
        display: inline-flex;
    }
    .miniprogram_selector__example {
        margin-top: 10px;
        text-align: left;
    }
    .miniprogram_selector__tips {
        color: #909090;
        font-size: 12px;
        line-height: 1.3;
        text-align: left;
    }
    .miniprogram_selector__image {
        margin-top: 10px;
        width: 180px;
        height: 300px;
        vertical-align: top;
    }
    .as-selector {
        border: 1px solid #e5e5e5;
        border-radius: 3px;
    }
    .as-selector__label {
        display: none;
    }
}
</style>